<template>
  <a
    :href="href"
    class="buy-card"
    :class="{ 'buy-card--horizontal': horizontal }"
  >
    <swiper :options="swiperOptions" v-if="images" ref="swiperInstance">
      <swiper-slide v-for="src in images" :key="src">
        <div class="aspect aspect--309x188">
          <img class="swiper-lazy" :data-src="src" alt />
        </div>
      </swiper-slide>
      <div
        slot="button-prev"
        v-if="images.length > 1"
        class="swiper-button-prev"
      >
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <circle opacity=".6" cx="16" cy="16" r="16" fill="#333" />
          <path d="M17.5 19l-3-3 3-3" stroke="#fff" stroke-width="1.5" />
        </svg>
      </div>
      <div
        slot="button-next"
        v-if="images.length > 1"
        class="swiper-button-next"
      >
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <circle opacity=".6" cx="16" cy="16" r="16" fill="#333" />
          <path d="M14.5 13l3 3-3 3" stroke="#fff" stroke-width="1.5" />
        </svg>
      </div>
    </swiper>

    <p
      class="buy-card__additional buy-card__additional--left buy-card__additional--green"
      v-if="additionalLeft"
      data-do-not-translate
    >
      {{ additionalLeft }}
    </p>

    <p class="buy-card__additional" v-if="additional" data-do-not-translate>
      {{ additional }}
      <span v-if="additionalSuffix" v-text="additionalSuffix"></span>
    </p>

    <div class="buy-card__content">
      <div class="buy-card__location contacts__location">
        <svg width="24" height="24" viewBox="0 0 16 16">
          <use xlink:href="#location" />
        </svg>
        <p v-text="location"></p>
      </div>

      <div class="buy-card__title title indent-xs title__no-center">
        <h5 style="font-size: 1.25rem !important" v-html="title"></h5>
      </div>

      <div class="buy-card__info">
        <p class="buy-card__price" v-if="price" v-html="price"></p>
        <p class="buy-card__bedrooms" v-if="bedrooms" v-html="bedrooms"></p>
      </div>

      <div
        class="buy-card__more button button__with-icon-right button__transparent"
        v-if="more"
      >
        <span v-text="moreText"></span>
        <svg class="icon" width="32" height="32" viewBox="0 0 46 48">
          <use xlink:href="#arrow-right" />
        </svg>
      </div>
    </div>
  </a>
</template>

<script>
// import { Navigation, Pagination, Lazy } from 'swiper';
// import { Swiper, SwiperSlide } from 'swiper/vue';
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import {
  Swiper as SwiperClass,
  Lazy,
  Navigation,
  Pagination,
} from 'swiper/core'

// we have a 'swiper/bundle' import in index.js thus we don't need:
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';

import swiperOverrides from '../scripts/swiperOverrides'

SwiperClass.use([Lazy, Navigation, Pagination])

const AwesomeSwiper = getAwesomeSwiper(SwiperClass)

// Vue.use(AwesomeSwiper)
const { Swiper, SwiperSlide } = AwesomeSwiper

export default {
  name: 'PropertyCard',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOptions: swiperOverrides.simple,
    }
  },
  props: {
    href: String,
    images: Array,
    additional: String,
    additionalLeft: String,
    additionalSuffix: String,
    location: String,
    title: String,
    price: String,
    bedrooms: String,
    more: Boolean,
    moreText: String,
    horizontal: Boolean,
  },
  computed: {
    swiper() {
      return this.$refs.swiperInstance && this.$refs.swiperInstance.$swiper
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.swiper) {
        this.swiper.update()
        this.swiper.navigation.update()
      }
    }, 0)
  },
  watch: {
    images() {
      if (this.swiper) {
        setTimeout(() => {
          this.swiper.slideToLoop(0, 0)
          this.swiper.lazy.load()
          this.swiper.navigation.update()
        }, 0)
      }
    },
  },
}
</script>
